<div class="row">
    <div class="col-sm-12" style="display: flex; justify-content: space-between;">
        <h3 class="col-sm-6"> Visualisation du {{this.bp.code}} {{this.bp.societe ? '('+ this.bp.societe.code + ')' :''}} </h3>
        <div class="col-sm-6" style=" justify-content: space-between;">
            <button color="default" mat-raised-button type="button" (click)="close()">
                <mat-icon>arrow_back</mat-icon>Retour à la liste
            </button>
            <app-pdf-bp [bp]="bp"></app-pdf-bp>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-10 padding-0" id="read-bp-container">
        <div>
            <app-bp-form 
                [form]="bpForm" 
                [detailInfo]="detailBpInfo" 
                [amountHT]="bpLineHTs" 
                [amountTTC]="bpLineTTCs"
                [amountTVA]="bpLineTVAs"
            ></app-bp-form>
            <br/>
        </div>
    </div> 
    <div [ngClass]="parentWidth < 576 ? 'padding-0 mb-4' : 'col-sm-2 padding-0'" id="cycles">
        <div *ngFor="let bc of bcs">
            <app-cycles-bc [cycles]="bc.cycleBcs" [title]="bc.code"></app-cycles-bc>
        </div>
        <app-cycles-bp [cycles]="bp.cycleBps" [title]="bp.code"></app-cycles-bp>
    </div>
    <mat-card  [ngClass]="childHeight < 285 ? 'col-sm-12' : 'col-sm-10'">
        <mat-card-content>
            <app-fixed-bp-line-list-validation class="row" [form]="bpForm"></app-fixed-bp-line-list-validation>
        </mat-card-content>
    </mat-card>
</div>
